import React, { useState } from 'react'

const Biharnearme = (props) => {
    return (
        <>
            <div id='footerdetail' >
                <div id='callus'>
                    <div className="container">
                        <div className="row">
                            {/*<!-- End Col --> */}
                            <div className="col-md-12 col-lg-12">

                                <div className="popular-city" style={{ display: 'flex' }}>
                                    <div className="footer-widget footer-left-widgetcties-pop popular-city-footers">
                                        <div className="section-heading">
                                            <h3>OUR PICK-UP & DROP FACILITIES AVAILABLE IN  BELOW LOCATIONS</h3>
                                            <span className="animate-border border-black"></span>
                                        </div>
                                        <ul>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Araria"><i className='fa fa-map-marker'></i> <u>Araria</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Arwal"><i className='fa fa-map-marker'></i> <u>Arwal</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Aurangabad"><i className='fa fa-map-marker'></i> <u>Aurangabad</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Banka"><i className='fa fa-map-marker'></i> <u>Banka</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Begusarai"><i className='fa fa-map-marker'></i> <u>Begusarai</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Bhabua"><i className='fa fa-map-marker'></i> <u>Bhabua</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Bhagalpur"><i className='fa fa-map-marker'></i> <u>Bhagalpur</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Bhojpur"><i className='fa fa-map-marker'></i> <u>Bhojpur</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Bihar-Sharif"><i className='fa fa-map-marker'></i> <u>Bihar Sharif</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Buxar"><i className='fa fa-map-marker'></i> <u>Buxar</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Sultanganj "><i className='fa fa-map-marker'></i> <u>Sultanganj </u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-kahalgaon "><i className='fa fa-map-marker'></i> <u>kahalgaon </u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Bakhtiyarpur "><i className='fa fa-map-marker'></i> <u>Bakhtiyarpur </u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Barh "><i className='fa fa-map-marker'></i> <u>Barh </u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Jamalpur "><i className='fa fa-map-marker'></i> <u>Jamalpur </u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Motihari "><i className='fa fa-map-marker'></i> <u>Motihari </u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Bettiah "><i className='fa fa-map-marker'></i> <u>Bettiah </u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Barahat "><i className='fa fa-map-marker'></i> <u>Barahat </u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Mandar-Hill "><i className='fa fa-map-marker'></i> <u>Mandar Hill </u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Raxaul "><i className='fa fa-map-marker'></i> <u>Raxaul </u></a>
                                            </li>

                                            <li>
                                                <a href="/Nasha-mukti-kendra-Chhapra"><i className='fa fa-map-marker'></i> <u>Chhapra</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Darbhanga"><i className='fa fa-map-marker'></i> <u>Darbhanga</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-East-Champaran"><i className='fa fa-map-marker'></i> <u>East Champaran</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Gaya"><i className='fa fa-map-marker'></i> <u>Gaya</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Gopalganj"><i className='fa fa-map-marker'></i> <u>Gopalganj</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Jamui"><i className='fa fa-map-marker'></i> <u>Jamui</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Jehanabad"><i className='fa fa-map-marker'></i> <u>Jehanabad</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Khagaria"><i className='fa fa-map-marker'></i> <u>Khagaria</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Kishanganj"><i className='fa fa-map-marker'></i> <u>Kishanganj</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Kaimur"><i className='fa fa-map-marker'></i> <u>Kaimur</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Katihar"><i className='fa fa-map-marker'></i> <u>Katihar</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Lakhisarai"><i className='fa fa-map-marker'></i> <u>Lakhisarai</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Madhubani"><i className='fa fa-map-marker'></i> <u>Madhubani</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Munger"><i className='fa fa-map-marker'></i> <u>Munger</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Madhepura"><i className='fa fa-map-marker'></i> <u>Madhepura</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Muzaffarpur"><i className='fa fa-map-marker'></i> <u>Muzaffarpur</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Nalanda"><i className='fa fa-map-marker'></i> <u>Nalanda</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Nawada"><i className='fa fa-map-marker'></i> <u>Nawada</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Patna"><i className='fa fa-map-marker'></i> <u>Patna</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Purnia"><i className='fa fa-map-marker'></i> <u>Purnia</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Rohtas"><i className='fa fa-map-marker'></i> <u>Rohtas</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Saharsa"><i className='fa fa-map-marker'></i> <u>Saharsa</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Samastipur"><i className='fa fa-map-marker'></i> <u>Samastipur</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Sasaram"><i className='fa fa-map-marker'></i> <u>Sasaram</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Sheohar"><i className='fa fa-map-marker'></i> <u>Sheohar</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Sheikhpura"><i className='fa fa-map-marker'></i> <u>Sheikhpura</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Saran"><i className='fa fa-map-marker'></i> <u>Saran</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Sitamarhi"><i className='fa fa-map-marker'></i> <u>Sitamarhi</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Supaul"><i className='fa fa-map-marker'></i> <u>Supaul</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Siwan"><i className='fa fa-map-marker'></i> <u>Siwan</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-Vaishali"><i className='fa fa-map-marker'></i> <u>Vaishali</u></a>
                                            </li>
                                            <li>
                                                <a href="/Nasha-mukti-kendra-West-Champaran"><i className='fa fa-map-marker'></i> <u>West Champaran</u></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}

export default Biharnearme;